import { logger } from "@/modules/monitoring/logger"

export const wait = async (delay: number): Promise<void> => {
  return new Promise<void>(resolve => {
    setTimeout(() => {
      resolve()
    }, delay)
  })
}

export const copyAsyncResponseToClipboard = async (promise: () => Promise<string>): Promise<void> => {
  try {
    if (typeof ClipboardItem === "undefined") {
      const string = await promise()
      await navigator.clipboard.writeText(string)
    } else {
      // workaround for Safari : https://stackoverflow.com/a/68241516
      const text = new ClipboardItem({
        "text/plain": promise().then(string => new Blob([string], { type: "text/plain" })),
      })
      await navigator.clipboard.write([text])
    }
  } catch (error) {
    logger.error(`An unhandled error occured while copying async response to clipboard: ${error}.`)
  }
}
